<div class="input-group">
  <input type="number" min="0" class="form-control" [ngClass]="inputClass" [attr.placeholder]="placeholder" [value]="modelValue" (keydown)="onKeyDown($event)"
    [formControl]="control" [attr.disabled]="disabled || modelUnit === 'unlimited' ?'':null">
  <div class="separator"></div>
  <button *ngFor="let unit of units" type="button" class="btn" [disabled]="disabled"
    [ngClass]="{'btn-primary': modelUnit === unit, 'btn-default': modelUnit !== unit}" (click)="setUnit(unit)">
    {{ labels[unit] }}
  </button>
</div>
<input-errors [control]="control" [service]="validationService"></input-errors>
